// extracted by mini-css-extract-plugin
export var links = "important-links-module--links--7c073";
export var text = "important-links-module--text--82200";
export var title = "important-links-module--title--34f4e";